import { useMatchRoute } from '@tanstack/react-router';

export const PORTFOLIO_SURFACE_BASE = '/org/$org/loop/$loopId/portfolio' as const;
export const PORTFOLIO_SAVED_VIEW_BASE = '/org/$org/loop/$loopId/portfolio/view/$viewId' as const;
export const VISUALIZATIONS_MAIN_BASE = '/org/$org/loop/$loopId/visualizations/main' as const;
export const VISUALIZATIONS_SAVED_VIEW_BASE =
  '/org/$org/loop/$loopId/visualizations/view/$viewId' as const;
export const VISUALIZATIONS_BASE = '/org/$org/loop/$loopId/visualizations' as const;

export type ViewSurfacePaths = {
  isMergedPortfolio: boolean;
  surfaceViewBase: typeof PORTFOLIO_SURFACE_BASE | typeof VISUALIZATIONS_MAIN_BASE;
  savedViewBase: typeof PORTFOLIO_SAVED_VIEW_BASE | typeof VISUALIZATIONS_SAVED_VIEW_BASE;
  surfaceHome: typeof PORTFOLIO_SURFACE_BASE | typeof VISUALIZATIONS_BASE;
};

const PORTFOLIO_SURFACE_PATHS: ViewSurfacePaths = {
  isMergedPortfolio: true,
  surfaceViewBase: PORTFOLIO_SURFACE_BASE,
  savedViewBase: PORTFOLIO_SAVED_VIEW_BASE,
  surfaceHome: PORTFOLIO_SURFACE_BASE,
};

const VISUALIZATIONS_SURFACE_PATHS: ViewSurfacePaths = {
  isMergedPortfolio: false,
  surfaceViewBase: VISUALIZATIONS_MAIN_BASE,
  savedViewBase: VISUALIZATIONS_SAVED_VIEW_BASE,
  surfaceHome: VISUALIZATIONS_BASE,
};

export function useViewSurfacePaths(): ViewSurfacePaths {
  const matchRoute = useMatchRoute();
  const isOnPortfolio = !!matchRoute({ to: PORTFOLIO_SURFACE_BASE, fuzzy: true });
  return isOnPortfolio ? PORTFOLIO_SURFACE_PATHS : VISUALIZATIONS_SURFACE_PATHS;
}
